// DS8.1.3
// DS8.1.3M - M - variant: vertical - but designers use it for desktop too
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import ModalWrapper from '../../ModalWrapper';
import ModalDoNotShowAgain from '../../ModalDoNotShowAgain';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';
const MessageModal = (_param)=>{
    var { variant, title, message, image, footerButtons, doNotShowAgainText, onDoNotShowAgainChange, contentClassName } = _param, rest = _object_without_properties(_param, [
        "variant",
        "title",
        "message",
        "image",
        "footerButtons",
        "doNotShowAgainText",
        "onDoNotShowAgainChange",
        "contentClassName"
    ]);
    return(// TODO: cleanup `as any` with the `complete_theme` feature
    /*#__PURE__*/ React.createElement(ModalWrapper, _object_spread({
        isFullscreen: false
    }, rest), variant === 'horizontal' ? /*#__PURE__*/ React.createElement(HorizontalLayout, {
        image: image,
        title: title,
        message: message,
        contentClassName: contentClassName,
        footerLeft: [
            onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
                key: "dns",
                doNotShowAgainText: doNotShowAgainText || '',
                onDoNotShowAgainChange: onDoNotShowAgainChange
            })
        ],
        footerRight: footerButtons
    }) : /*#__PURE__*/ React.createElement(VerticalLayout, {
        image: image,
        title: title,
        message: message,
        contentClassName: contentClassName,
        footerButtons: footerButtons,
        footerExtras: onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
            key: "dns",
            doNotShowAgainText: doNotShowAgainText || '',
            onDoNotShowAgainChange: onDoNotShowAgainChange
        })
    })));
};
MessageModal.displayName = 'MessageModal';
export default MessageModal;
